var map = {
	"./driver.longhorn.io.vue": 47487,
	"./index.vue": 80990,
	"edit/workload/storage/csi/driver.longhorn.io.vue": 47487,
	"edit/workload/storage/csi/index.vue": 80990
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 15494;